import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global unhandled promise rejection handler for debugging
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise Rejection:', event.reason);
  console.error('Promise:', event.promise);
  // Prevent the default browser error overlay for handled cases
  if (event.reason === undefined || event.reason === null) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
